module.exports = __webpack_public_path__ + "static/media/Tiny-Poker_logo.2944857c.png";